var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"certificate-modal",attrs:{"title":"Certificate","size":"lg","ok-only":""}},[_c('b-img',{attrs:{"src":_vm.image_path,"fluid":"","alt":"Certificate"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }